'use strict';
var $ = require('../internals/export');
var exec = require('../internals/regexp-exec');

$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});



//////////////////
// WEBPACK FOOTER
// ./~/vue-tel-input/~/core-js/modules/es.regexp.exec.js
// module id = 1547
// module chunks = 1